<template>
  <div class="user-subscription">
    <div class="card-box">
      <div class="user-subs">
        <UserSubscriptionBox
          v-for="(sub, idx) in subs"
          :key="idx"
          class="mb-4 mr-4 user-subs_item"
          :sub="sub"
          :hasFreeText="nadaPurchased"
        />
      </div>
    </div>
    <div
      v-if="canCancel"
      class="bt-grey cancel-subscription-container"
    >
      <div
        data-tst="btn_cancel_sub"
        class="cancel-subscription-btn clr-error"
        color="transparent"
        @click="handleCancelSubClick"
      >
        {{ $t('user_settings.cancel_subscription') }}
      </div>
      <div class="cancel-subscription-text">
        {{ $t('user_settings.cancel_subscription_sub') }}
      </div>
    </div>
  </div>
</template>

<script>
import UserSubscriptionBox from '@/components/Sub/UserSubscriptionBox'
import format_mix from '@/mixins/format_mix'
import { getGametypeOrder } from '@/helpers/constants'
import tier_mix from '@/mixins/tier_mix'

export default {
  name: 'UserSubscription',

  components: {
    UserSubscriptionBox,
  },
  mixins: [format_mix, tier_mix],
  data() {
    return {
      reactivateLoading: false,
    }
  },
  // mounted() {
  //   if (!this.purchasedSubs.length) return
  //   setTimeout(() => {
  //     seg_track('subscription_dashboard_viewed', {
  //       products: this.purchasedSubs.map(i => ({
  //         ...seg_getProduct(i),
  //         quantity: 1,
  //       })),
  //     })
  //   }, 1000)
  // },
  methods: {
    handleCancelSubClick() {
      // seg_track('cancel_subscription_click')
      this.$store.dispatch('router_set_dialogs', 'cancel-payment-plan-dialog')
    },
  },
  computed: {
    user_info() {
      const { user_info } = this.$store.getters
      return user_info
    },
    subs() {
      let res = JSON.parse(JSON.stringify(this.user_info.subs || []))
      const order = getGametypeOrder()
      res = res.sort((a, b) =>
        order.indexOf(a.plan?.type.toLowerCase()) < order.indexOf(b.plan?.type.toLowerCase())
          ? -1
          : 1,
      )
      if (res.length > 4) {
        res = res.filter(sub => sub.plan?.type.toLowerCase() !== 'any')
      }
      // console.log(res)
      return res
    },
    canCancel() {
      const res = this.user_info.subs || []
      return res.some(p => p.plan.game_format.toLowerCase() !== 'any' && !p.canceled)
    },
  },
}
</script>
<style lang="scss" scoped>
@media (max-width: 1023px) {
  .card-box {
    flex-direction: column;
    &_title {
      margin-bottom: 1rem;
    }
  }
}
.user-subscription {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.card-box {
  display: flex;
  border-radius: 4px;
  flex-shrink: 0;

  &_title {
    min-width: 12rem;
  }
}

.cancel-subscription-container {
  position: relative;
  margin-top: auto;
  padding: 1rem 0;
  .cancel-subscription-btn {
    font-weight: 500;
    &:hover {
      cursor: pointer;
      font-weight: 700;
    }
  }
  .cancel-subscription-text {
    font-size: 0.8rem;
    color: var(--clr-grey-2);
  }
}
.subscription-info-box {
  padding: 1rem;
  background: var(--clr-black-1-3);
  border-radius: 4px;
}
</style>
